// extracted by mini-css-extract-plugin
module.exports = {"jds-CardTagsListing":"cardTagListing_jds-CardTagsListing__O6NOO","jds-CardTagsListing__item":"cardTagListing_jds-CardTagsListing__item__WHxmt"};